import React from 'react';
import * as MeasureDisplayFormatUI from './MeasureDisplayFormatUI';
import { SingleSelectMenu } from '../../Dropdown';

interface IProps {
  value: string | null;
  onChange: (value: string) => void;
  placeholder?: string;
}

const defaultDecimalPlaceOptions = [
  {
    text: '#',
    value: '0',
  },
  {
    text: '#.0',
    value: '1',
  },
  {
    text: '#.00',
    value: '2',
  },
  {
    text: '#.000',
    value: '3',
  },
  {
    text: '#.0000',
    value: '4',
  },
];

const MeasureDisplayFormatPrecision = ({
  value,
  onChange,
  placeholder,
}: IProps) => {
  return (
    <MeasureDisplayFormatUI.FormRow>
      <MeasureDisplayFormatUI.FormLabel>
        Precision
      </MeasureDisplayFormatUI.FormLabel>
      <SingleSelectMenu
        value={value || ''}
        onChange={onChange}
        options={defaultDecimalPlaceOptions}
        placeholder={placeholder}
      />
    </MeasureDisplayFormatUI.FormRow>
  );
};

export default MeasureDisplayFormatPrecision;
